import React, { useEffect, useState } from "react";
import "./styles/BookCard.css";
import { useHistory } from "react-router-dom";

//loader
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const loadingColor = "#8C9BD8";

const BookCard = ({ book, size }) => {
  const [hovering, setHovering] = useState(false);
  const [bookCoverURL, setBookCoverURL] = useState(null);
  const [imgLoading, setImgLoading] = useState(true);
  // const [img, setImg] = useState();
  const location = useLocation();
  let history = useHistory();

  const override = css`
    top: ${size === "large" ? "130px" : "25px"};
    position: relative;
  `;

  useEffect(() => {
    if (book.bookCoverLink)
      setBookCoverURL(
        `https://d24hdgytax3x03.cloudfront.net/${book.id}/${book.bookCoverLink}`
      );
    // console.log("book: ", book);
  }, [book]);

  // useEffect(() => {
  //   console.log(bookString);
  // }, [bookString]);

  const goToBook = (mode) => {
    updateRecentBooks();
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("tab", mode);

    if (mode === "develop") {
      history.push(`/authoring-tool-2.0?book=${book.id}`);
    } else {
      history.push({
        pathname: `/books/${book.id}`,
        search: queryParams.toString(),
      });
    }
  };

  const goToBookDetails = () => {
    updateRecentBooks();
    history.push({
      pathname: `/books/${book.id}`,
      state: { mode: "details", isNew: false, existingBookId: book.id },
    });
  };

  const goToDevelopBook = () => {
    updateRecentBooks();
    history.push({
      pathname: `/books/${book.id}`,
      state: { mode: "develop" },
    });
  };

  const goToResources = () => {
    updateRecentBooks();
    history.push({
      pathname: `/books/${book.id}`,
      state: { mode: "recourses" },
    });
  };

  // update the recently edited books in localStorage
  // (this fires when going into any of the three modes
  // ("details", "develop", "resources"))
  function updateRecentBooks() {
    let temp = JSON.parse(localStorage.getItem("recentbooks"));

    // if (no recent books) {...} else {...}
    if (temp === null) {
      temp = [
        { index: 0, id: book.id, title: book.title, image: bookCoverURL },
      ];
      localStorage.setItem("recentbooks", JSON.stringify(temp));
    } else {
      let bookAlreadyInArray = temp.find((b) => b.id === book.id);

      // this book is already in recentbooks
      if (bookAlreadyInArray) {
        temp.splice(bookAlreadyInArray.index, 1);
      }
      temp.unshift({
        index: 0,
        id: book.id,
        title: book.title,
        image: bookCoverURL,
      });
    }

    // re-assign the indices
    if (temp?.length > 1) {
      temp.forEach((el, i) => (el.index = i));
      if (temp?.length > 10) {
        temp.pop();
      }
    }

    // finally, update localStorage
    localStorage.setItem("recentbooks", JSON.stringify(temp));
  }

  return (
    // <div className="card-border-wrap">
    <div
      style={{ position: "relative", overflow: "hidden", borderRadius: "3px" }}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <div className={`card-container ${hovering ? "hovering" : ""} ${size}`}>
        <div className="img-container">
          {imgLoading && (
            <div>
              <ClipLoader
                color={loadingColor}
                loading={imgLoading}
                css={override}
                // style={{ marginTop: "100px" }}
              />
            </div>
          )}

          <img
            style={{ visibility: imgLoading ? "hidden" : "visible" }}
            src={bookCoverURL}
            onLoad={() => setImgLoading(false)}
            className="image"
            alt={`${book.title}_cover`}
          />
        </div>
        <div className="text-fields">
          <span className="book-title">{book.title}</span>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {book?.roleDtos?.slice(0, 2).map((role, i) => {
              return (
                <span key={i} className="role-label">
                  {role.creator_name}
                </span>
              );
            })}
            {book?.roleDtos?.length >= 3 && (
              <span className="role-label">...</span>
            )}
          </div>
        </div>
      </div>
      <div className={`card-buttons ${hovering ? "visible" : ""}`}>
        <button
          className="card-button"
          id="details"
          onClick={() => goToBook("details")}
        >
          Details
        </button>
        <button
          className="card-button"
          id="develop"
          onClick={() => goToBook("develop")}
        >
          Develop
        </button>
        <button
          className="card-button"
          id="resources"
          onClick={() => goToBook("resources")}
        >
          Resources
        </button>
      </div>
      {/* <div className={"buttons"}>
        <button className={`card-button ${hovering ? "" : "hidden"}`} onClick={goToBookDetails}>
          Edit Details
        </button>
        <button className={`card-button ${hovering ? "" : "hidden"}`} onClick={goToDevelopBook}>
          Develop
        </button>
        <button className={`card-button ${hovering ? "" : "hidden"}`} onClick={goToResources}>
          Resources
        </button>
      </div> */}
    </div>
  );
};

export default BookCard;
